import { render, staticRenderFns } from "./ByJsonFileContainer.vue?vue&type=template&id=1a641502&scoped=true&"
import script from "./ByJsonFileContainer.vue?vue&type=script&lang=js&"
export * from "./ByJsonFileContainer.vue?vue&type=script&lang=js&"
import style0 from "./ByJsonFileContainer.vue?vue&type=style&index=0&id=1a641502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a641502",
  null
  
)

export default component.exports